/**
 * stale-snapshot-error.ts — 乐观并发冲突（陈旧快照）的运营向提示。
 *
 * 服务端在行锁内比对 `expected_updated_at`，不等则整笔拒绝（422 `RESOURCE_CONFLICT` +
 * `details.reason = 'STALE_SNAPSHOT'`）。这里把它翻成运营看得懂的一句话。
 *
 * **文案必须说「未保存」而不是「可能未保存」**：这条错误的前提就是服务端在任何写之前拒绝了请求，
 * 本地改动确定还在表单里、库里一个字节都没动。这与超时 / 中止（`AdminRequestTimeoutError`，
 * `serverStateUnknown = true`，见 `api/errors.ts`）恰好相反 —— 那种情况下请求可能已经落库，文案
 * 只能说「服务端可能仍在处理」。两者共用一句模糊文案会让运营在本可确定的场景里也不敢重试。
 */

import { AdminApiError } from '~/api/errors';
import { detailsReasonIs } from './details-reason';

const RESOURCE_CONFLICT = 'RESOURCE_CONFLICT';
const STALE_SNAPSHOT = 'STALE_SNAPSHOT';

/**
 * 命中「载入后被他人改过」→ 返回提示文案；否则返回 null（交给调用方的既有兜底分支）。
 *
 * @param subject 被编辑对象的名字，进文案（如「书籍信息」）
 */
export function staleSnapshotErrorMessage(err: unknown, subject: string): string | null {
  if (!(err instanceof AdminApiError) || err.code !== RESOURCE_CONFLICT) return null;
  // 过渡期大小写不敏感（dd#1008 改名的部署窗口，见 `./details-reason` 文件头）
  if (!detailsReasonIs(err.details, STALE_SNAPSHOT)) return null;
  return `${subject}在你编辑期间被其他人改过，本次未保存。请刷新载入最新内容后重新修改——直接重试会覆盖对方的改动。`;
}
